var _effectorFileName = "/builds/gmini/front-sm-api-sdk/src/NavigationModelRepo/CommonProjectSourceTypeEnum.ts";
import * as t from 'io-ts';
export var CommonProjectSourceTypeEnum = t.union([t.literal('Bim360'), t.literal('GStation')]);